import { render, staticRenderFns } from "./widget-component-overview.vue?vue&type=template&id=f2823e8e&scoped=true"
import script from "./widget-component-overview.vue?vue&type=script&lang=ts"
export * from "./widget-component-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2823e8e",
  null
  
)

export default component.exports